export enum layoutTypes {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

export enum layoutTheme {
  LIGHTMODE = "light",
  DARKMODE = "dark"
}

export enum layoutWidthTypes {
  FLUID = "fluid",
  BOXED = "boxed",
}

export enum layoutPositions {
  SCROLLABLE_TRUE = "true",
  SCROLLABLE_FALSE = "false"
}

export enum topBarThemeTypes {
  LIGHT = "light",
  DARK = "dark"
}

export enum leftSidebarTypes {
  DEFAULT = "lg",
  COMPACT = "md",
  ICON = "sm",
}

export enum leftSideBarThemeTypes {
  LIGHT = "light",
  COLORED = "brand",
  DARK = "dark",
}